import BoletosClient from '@/api/Operacoes/boletos.client';

export default class BoletosPedidosService {
  constructor() {
    this.client = new BoletosClient();
  }

  async getBoletos(query) {
    return new Promise((resolve, reject) => {
      this.client.getBoletoList(query)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async generateBoleto(data) {
    return new Promise((resolve, reject) => {
      this.client.genereteBoleto(data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
